import { API_URL } from "./api";

export function getAttachmentUrl(url: string | null | undefined): string {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (API_URL.startsWith("http://") || API_URL.startsWith("https://")) {
    try {
      return `${new URL(API_URL).origin}${url}`;
    } catch {
      return `${API_URL.replace(/\/api\/?$/, "")}${url}`;
    }
  }
  return url;
}
